<script lang="ts">
  import type { NotificationPayload } from './types'

  interface Props {
    message: string
    payload: NotificationPayload
    onDismiss: () => void
  }

  let { message, payload, onDismiss = () => null }: Props = $props()

  const close = () => {
    onDismiss()
  }
</script>

<div class="toast {payload.type}">
  {#if payload.type === 'generic'}
    <div class="content">
      <h4>
        {payload.title}
      </h4>
      {#if payload.description}
        <p>{payload.description}</p>
      {/if}
    </div>
  {:else}
    <p>{message}</p>
  {/if}

  <button
    aria-label="Close"
    data-testid="close-button"
    class="close"
    onclick={close}
  >
    <svg
      width="14"
      height="14"
      viewBox="0 0 16 16"
      stroke="currentColor"
      stroke-width="1.75"
    >
      <line x1="3" y1="3" x2="13" y2="13"></line>
      <line x1="13" y1="3" x2="3" y2="13"></line>
    </svg>
  </button>
</div>

<style lang="postcss">
  .toast {
    display: block;
    position: relative;
    box-sizing: border-box;
    border: 1px solid var(--color-bg);
    border-radius: var(--radius-lg);
    background: var(--color-bg-surface);
    padding: 1rem 2.5rem 1rem 1rem;
    width: 356px;
  }
  .content {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  .actions {
    display: flex;
    gap: 0.5rem;
  }

  h4 {
    margin: 0;
    color: var(--color-text-secondary);
    font-weight: 600;
    font-size: var(--scale-0);
    line-height: 1;
    font-family: var(--font-text);
  }
  p {
    font-size: var(--scale-00);
  }

  h4,
  p {
    display: block;
    margin: 0;
    line-height: 120%;
  }

  .close {
    position: absolute;
    top: 0.6em;
    right: 0.45rem;
    transition: color 200ms;
    cursor: pointer;
    border: none;
    background: transparent;
    padding: 0.5rem;
    width: 2rem;
    height: 2rem;
    color: var(--color-text-tertiary);
    svg {
      display: block;
      width: 100%;
      height: 100%;
    }
    &:hover {
      color: var(--color-text-secondary);
    }
  }
</style>
